export const POLICY_LAST_UPDATED = "April 9, 2026";

export const COMPANY_DETAILS = {
  name: "PC Care Computer",
  website: "https://pccarecomputer.com",
  email: "info@pccarecomputers.com",
  emailHref: "mailto:info@pccarecomputers.com",
  phone: "+91 9238264606",
  phoneHref: "tel:+919238264606",
  address:
    "PC Care Computer, 1035 Malviya Chowk, Infront Of Yatayat Thana, Jabalpur (MP) 482001",
  mapHref: "https://www.google.com/maps?q=23.168639,79.931806",
  supportHours: "Monday to Saturday, 10:00 AM to 7:00 PM",
  jurisdiction: "Jabalpur, Madhya Pradesh",
};
